import { Tooltip } from 'antd';
import cs from 'classnames';

import { ReactComponent as InfoCircleIcon } from 'assets/icons/info-circle.svg';

import styles from './LabelWithTooltip.module.scss';

interface LabelWithToolTipProps {
  label: string;
  tooltip?: string;
  isRequired?: boolean;
}

const LabelWithTooltip = ({
  label,
  tooltip,
  isRequired
}: LabelWithToolTipProps): JSX.Element => {
  return (
    <div className={styles.labelWithTooltip}>
      <span className={styles.label}>{label}</span>
      {tooltip && (
        <Tooltip
          title={tooltip}
          placement="top"
          trigger="hover"
          className={styles.tooltip}
        >
          <InfoCircleIcon
            className={cs(styles.infoIcon, {
              [styles.required]: isRequired
            })}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default LabelWithTooltip;
